import React from "react";

import { LineProcess as LineProcessComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface LineProcessProps {
    isInsideModal?: boolean;
    subDimensionsData?: any;
}

const LineProcess: React.FC<LineProcessProps> = ({ isInsideModal, subDimensionsData }) => {
    const { lineProcessData, isFetchingLineProcess, isErrorLineProcess } =
        useSessionDetailsContext();

    const isEmptyState = () => {
        if (isInsideModal) {
            return (
                !subDimensionsData ||
                !subDimensionsData ||
                (Array.isArray(subDimensionsData) && subDimensionsData?.length === 0)
            );
        } else if (
            !isErrorLineProcess &&
            (!lineProcessData || Object.keys(lineProcessData?.resultsTableData)?.length === 0)
        ) {
            return true;
        }
    };

    if (isFetchingLineProcess) {
        return <ContentLoader height="44rem" />;
    }

    if (!subDimensionsData && isErrorLineProcess && !isFetchingLineProcess) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="41rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState()) {
        <ComponentWrapper>
            <EmptyState
                title="session-details:cycle-container:empty-state:title"
                emptyStateType={EmptyStateType.Charts}
                minHeight="40.125rem"
            />
        </ComponentWrapper>;
    }

    return <LineProcessComponent data={isInsideModal ? subDimensionsData : lineProcessData} />;
};

export default LineProcess;
